import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'PhoneMask'
})
export class PhonePipe implements PipeTransform {
    public transform(value: any, hidden?: boolean): string {
        if (!value) {
            return '';
        }

        let str = value.toString().replace(/\D/g, '');

        if (str.charAt(0) === '0') {
            str = str.replace(/^(\d{4})(\d{3})(\d{4})/, '$1 $2 $3'); // 0800 000 0000 [11]
        } else if (str.length === 13) {
            const masked = `$1 ($2) ${hidden ? '*****' : '$3'} $4`;
            str = str.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, masked); // 55 (11) 94444 3333 [13]
        } else if (str.length === 12) {
            const masked = `$1 ($2) ${hidden ? '****' : '$3'} $4`;
            str = str.replace(/^(\d{2})(\d{2})(\d{4})(\d{4})/, masked); // 55 (11) 4444 3333 [12]
        } else if (str.length === 11) {
            const masked = `($1) ${hidden ? '*****' : '$2'} $3`;
            str = str.replace(/^(\d{2})(\d{5})(\d{4})/, masked); // (11) 94444 3333 [11]
        } else if (str.length === 10) {
            const masked = `($1) ${hidden ? '****' : '$2'} $3`;
            str = str.replace(/^(\d{2})(\d{4})(\d{4})/, masked); // (11) 4444 3333 [10]
        } else if (str.length === 8) {
            const masked = `${hidden ? '****' : '$1'} $2`;
            str = str.replace(/^(\d{4})(\d{4})/, masked); // 4444 3333 [8]
        } else {
            str = value;
        }

        return str;
    }
}
